class ErrorMessageConverter {
  errors: any;

  constructor(errors: any) {
    this.errors = errors;
  }

  getErrorMessage() {
    const statusCode = this.errors.status;

    if (statusCode === 429) {
      return 'You have exceeded the amount of requests. Please try again after some time.';
    } else if (statusCode === 500) {
      return 'Please try again after some time.';
    } else if (statusCode === 400) {
      return 'This verification link is expired.';
    }
    return this.errors.statusText ?? 'Please try again after some time.';
  }
}

export default ErrorMessageConverter;
